import tw, { styled } from 'twin.macro'
import { mobile } from '@flowwai-frontend/shared/utils/web'

export const TaskManagementHeaderLoadingWrapper = styled.div`
   ${tw`flex justify-between border flex-shrink-0  items-center`}
   height: 68px;
   ${mobile} {
      height: 56px;
   }
   width: 100%;
   border: 0 solid #e2e8f0;
   background: white;
`
export const AppPrefixAndDisplaNameLoadingWrapper = styled.div`
   ${tw`flex items-center`}
   padding-left: 28px;
`

export const MobileAppProfileLoadingWrapper = styled.div`
   ${tw`flex items-center`}
   padding-left: 16px;
`
